import { css } from "@emotion/react";
import { theme } from "styles/theme";
export const HeaderCustomStyle = {
  container: () => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    background-size: cover;
    height: 3rem;
    padding: 0 1rem;
    position: sticky;
    top: 0;
    background: ${theme.colors.gradient[1]};
    z-index: 99;
    .icon-back {
      width: 1.5rem;
      height: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      svg {
        fill: ${theme.colors.black};
      }
    }

    .title {
      margin-right: 1.5rem;
      margin-left: 0.5rem;
      color: ${theme.colors.black};
      font-size: 0.9375rem;
      font-weight: 600;
      line-height: 1.125rem;
      flex: 1;
      text-align: center;
    }
  `,
};
